export default __webpack_public_path__ + "locales/sl/Ldap.json?hash=5c8c02cafd9730d8dbdb173346a97dd0";